const SEO_CONFIG = require("../config/seo.config.json");
const { getSameAs } = require("../config/socialLinks");

const DEFAULT_LANG = "en_US";
const LANG_PATH_MAP = {
  en_US: "en-us",
  zh_CN: "zh-cn",
  zh_TW: "zh-tw",
  ko_KR: "ko-kr",
  ja_JP: "ja-jp",
  ru_RU: "ru-ru",
  id_ID: "id-id",
  vi_VN: "vi-vn",
};

function buildLangPath(lang, pathSegment = "") {
  const normalizedPath = pathSegment
    ? pathSegment.startsWith("/")
      ? pathSegment
      : `/${pathSegment}`
    : "";
  if (!lang || lang === DEFAULT_LANG) {
    return normalizedPath || "/";
  }
  const segment = LANG_PATH_MAP[lang] || lang.replace("_", "-").toLowerCase();
  return `/${segment}${normalizedPath}`;
}

function buildStructuredData({
  lang,
  canonical,
  seoInfo,
  siteOrigin,
  inLanguage,
}) {
  const structuredData = SEO_CONFIG.structuredData;
  const homeUrl = `${siteOrigin}${buildLangPath(lang, "")}`;
  const sameAs = getSameAs(lang);
  const homeBreadcrumbName =
    structuredData.homeBreadcrumb?.[lang] ||
    structuredData.homeBreadcrumb?.[DEFAULT_LANG] ||
    "Home";

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${siteOrigin}/#organization`,
        name: structuredData.organizationName,
        alternateName: structuredData.alternateNames,
        url: siteOrigin,
        logo: structuredData.logoUrl,
        sameAs,
      },
      {
        "@type": "WebSite",
        "@id": `${siteOrigin}/#website`,
        url: siteOrigin,
        name: structuredData.siteName,
        publisher: {
          "@id": `${siteOrigin}/#organization`,
        },
        inLanguage,
      },
      {
        "@type": "WebPage",
        "@id": `${canonical}#webpage`,
        url: canonical,
        name: seoInfo.title,
        description: seoInfo.description,
        isPartOf: {
          "@id": `${siteOrigin}/#website`,
        },
        about: {
          "@id": `${siteOrigin}/#organization`,
        },
        inLanguage,
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${canonical}#breadcrumb`,
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: homeBreadcrumbName,
            item: homeUrl,
          },
        ],
      },
    ],
  };
}

function buildStructuredDataScript({
  lang,
  canonical,
  seoInfo,
  siteOrigin,
  inLanguage,
}) {
  return `<script type="application/ld+json" data-seo="structured">${JSON.stringify(
    buildStructuredData({ lang, canonical, seoInfo, siteOrigin, inLanguage }),
  )}</script>`;
}

module.exports = {
  buildStructuredData,
  buildStructuredDataScript,
};
